import { LoadingState } from "../../models/loadingModels";
import { ApiStatusActionTypes } from "../actions/apiStatusActions";
import InitialState from "./initialState";

const initialState: LoadingState = InitialState.loading;

export default function LoadingReducer(
  state: LoadingState = initialState,
  action: any
) {
  if (action.type === ApiStatusActionTypes.Begin_Api_Call) {
    return {
      ...state,
      count: state.count + (action.payload?.count || 1),
      message: action.payload?.message || "",
      type: action.payload?.type || 0,
    };
  }

  if (
    (action.type === ApiStatusActionTypes.Api_Call_Error ||
      action.type === ApiStatusActionTypes.Stop_Loading_error) &&
    !action.preserveLoadingCount
  ) {
    return {
      ...state,
      count: state.count > 0 ? state.count - 1 : 0,
      type: state.count > 1 ? state.type : 0,
    };
  }

  // Any completed action dispatched by actions/thunks
  if (
    typeof action.type === "string" &&
    !action.preserveLoadingCount &&
    action.type !== ApiStatusActionTypes.Begin_Api_Call &&
    (action.type.startsWith("[") ||
      action.type.includes("Action") ||
      action.type.includes("ACTION") ||
      action.type.includes("Success") ||
      action.type.includes("SUCCESS") ||
      action.type.includes("Error") ||
      action.type.includes("ERROR") ||
      action.type.includes("Status") ||
      action.type.includes("STATUS") ||
      action.type.startsWith("GET_") ||
      action.type.startsWith("SET_"))
  ) {
    return {
      ...state,
      count: state.count > 0 ? state.count - 1 : 0,
      type: state.count > 1 ? state.type : 0,
    };
  }

  return state;
}
